<template>
  <v-text-field v-model="cmpValue"
                v-bind:label="label"
                v-bind:hint="hint"
                v-bind:placeholder="placeholder"
                v-bind:readonly="readonly"
                v-bind:disabled="disabled"
                v-bind:outlined="outlined"
                v-bind:dense="dense"
                v-bind:hide-details="hideDetails"
                v-bind:rules="rules"
                v-bind:clearable="clearable"
                v-bind:backgroundColor="backgroundColor"
                v-bind:prefix="options.prefix"
                v-bind:suffix="options.suffix"
                v-on:keypress="keyPress"
                v-on:keyup="keyUp"
                @focus="$event.target.select()"
                :error-messages="errors">
  </v-text-field>
</template>
<script>
  // WrsVuetifyNumber.vue
  export default {
    name: "WrsVuetifyNumber",
    props: {
      value: {
        // type: String,
        type: [String, Number],
        default: "0"
      },
      label: {
        type: String,
        default: ""
      },
      hint: {
        type: String,
        default: ""
      },
      placeholder: {
        type: String,
        default: undefined
      },
      readonly: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: [Boolean, String],
        default: false
      },
      rules: {
        type: [Array, String],
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      },
      outlined: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      backgroundColor: {
        type: String,
        default: "white"
      },
      valueWhenIsEmpty: {
        type: String,
        default: ""  // "0" or "" or null
      },
      errors: {
        type: Array,
        default() {
          return []
        }
      },
      options: {
        type: Object,
        default: function () {
          return {
            locale: "en-CA",
            prefix: "",
            suffix: "",
            length: 10
          };
        },
      },
      format: {
        type: String,
        default: "int"  //int, decimal, currency, percent
      },
    },
    data: () => ({}),
    /*
     v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
     O valor digitado entra pelo newValue do Set e é emitido para o componente pai.
     the-vue-mask nao funciona corretamente ao incluir valores existentes no componente pai.
    */
    computed: {
      cmpValue: {
        get: function () {
          return this.value !== null && this.value !== ""
            ? this.humanFormat(this.value.toString(), false)
            : this.valueWhenIsEmpty;
        },
        set: function (newValue) {
          this.$emit("input", this.machineFormat(newValue));
        },
      },
      precision: {
        get: function () {
          if (this.format == "int") {
            return 0;
          }
          else {
            return 2;
          }
        }
      },
      localeStyle: {
        get: function () {
          //decimal, currency, percent
          if (this.format == "int" || this.format == "decimal") {
            return "decimal";
          }
          else {
            return this.format;
          }
        }
      }
    },
    methods: {
      humanFormat: function (number, isOnBlur) {
        if (isNaN(number)) {
          number = "";
        } else {
          // number = Number(number).toLocaleString(this.options.locale, {maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
          // https://www.techonthenet.com/js/number_tolocalestring.php
          if (isOnBlur) {
            number = Number(number).toLocaleString(this.options.locale, {
              maximumFractionDigits: this.precision,
              minimumFractionDigits: this.precision,
              style: this.localeStyle,
              useGrouping: false
            });
          }
          else {
            number = Number(number).toLocaleString(this.options.locale, {
              maximumFractionDigits: this.precision,
              minimumFractionDigits: 0,
              style: this.localeStyle,
              useGrouping: false
            });
          }
        }
        return number;
      },
      machineFormat(number) {
        if (number) {
          if (isNaN(number)) {
            number = this.valueWhenIsEmpty;
          }
        } else {
          number = this.valueWhenIsEmpty;
        }
        if (this.precision === 0) {
          number = this.cleanNumber(number);
        }
        return number;
      },
      keyPress($event) {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if (keyCode == 46) {
          // 46 is dot
          if (this.precision == 0) {
            $event.preventDefault();
          }
        } else {
          if ((keyCode < 48 || keyCode > 57)) {
            $event.preventDefault();
          }
        }
        if (keyCode >= 48 && keyCode <= 57) {
          if (this.formatAcchieved()) {
            $event.preventDefault();
          }
        }
        if (this.targetLength()) {
          $event.preventDefault();
        }
      },
      keyUp($event) {
        const key = $event.key;
        if (key === "Backspace" || key === "Delete") {
          this.$emit("deletion-detected");
        }
      },
      // Retira todos os caracteres não numéricos e zeros à esquerda
      cleanNumber: function (value) {
        let result = "";
        if (value) {
          let flag = false;
          let arrayValue = value.toString().split("");
          for (var i = 0; i < arrayValue.length; i++) {
            if (this.isInteger(arrayValue[i])) {
              if (!flag) {
                // Retirar zeros à esquerda
                if (arrayValue[i] !== "0") {
                  result = result + arrayValue[i];
                  flag = true;
                }
              } else {
                result = result + arrayValue[i];
              }
            }
          }
        }
        return result;
      },
      isInteger(value) {
        let result = false;
        if (Number.isInteger(parseInt(value))) {
          result = true;
        }
        return result;
      },
      formatAcchieved() {
        if (this.precision == 0) return false;
        var fn = "" + this.value;
        if (fn.includes(".")) {
          let numParts = fn.split('.');
          if (numParts.length > 1) {
            if (numParts[1].length >= this.precision) return true;
          }
        }
        return false;
      },
      targetLength() {
        if (
          Number(this.cleanNumber(this.value).length) >=
          Number(this.options.length)
        ) {
          return true;
        } else {
          return false;
        }
      },
    },
  };
</script>
